import { CommonModule, NgIf } from '@angular/common'
import { Component, Input, OnChanges } from '@angular/core'
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms'
import { ButtonComponent } from '@progress/kendo-angular-buttons'
import { DropDownListComponent } from '@progress/kendo-angular-dropdowns'
import { AddCommandDirective, CancelCommandDirective, CellTemplateDirective, ColumnComponent, CommandColumnComponent, DataBindingDirective, EditCommandDirective, EditTemplateDirective, FocusableDirective, GridComponent, GridToolbarFocusableDirective, RemoveCommandDirective, SaveCommandDirective, ToolbarTemplateDirective } from '@progress/kendo-angular-grid'
import { ClientServices } from '../../../../@theme/services/clients.service'
import { TypesServices } from '../../../../@theme/services/typeslist.service'
import { IaState } from '../../../../models/repEditorModels'
import { GridEditorBaseComponent } from '../../shared/rep-editor-base/grid-editor-base-component'
import { RepEditorStateService } from '../../shared/rep-editor-state.service'
import { AdminOnlyDirective } from '../shared/admin-only.directive'

@Component({
    selector: 'gd-rep-editor-ia-states',
    templateUrl: './rep-editor-ia-states.component.html',
    styleUrls: ['./rep-editor-ia-states.component.scss'],
    imports: [
        CommonModule,
        GridComponent,
        DataBindingDirective,
        ToolbarTemplateDirective,
        GridToolbarFocusableDirective,
        AddCommandDirective,
        ButtonComponent,
        ColumnComponent,
        EditTemplateDirective,
        DropDownListComponent,
        FormsModule,
        ReactiveFormsModule,
        CommandColumnComponent,
        CellTemplateDirective,
        FocusableDirective,
        EditCommandDirective,
        NgIf,
        RemoveCommandDirective,
        SaveCommandDirective,
        CancelCommandDirective,
        AdminOnlyDirective
    ]
})
export class RepEditorIaStatesComponent
  extends GridEditorBaseComponent
  implements OnChanges
{
  activeStateList = this.repState.getActiveStateList()
  @Input() override repId: number = 0
  constructor(
    typesService: TypesServices,
    clientService: ClientServices,
    formBuilder: UntypedFormBuilder,
    repEditorStateService: RepEditorStateService,
  ) {
    super(typesService, clientService, formBuilder, repEditorStateService)
  }

  ngOnChanges() {
    this.checkGridState()

    if (!this.repState.repIaStates) {
      this.initGrid()
    }

    if (!this.repState.stateList) {
      this.typesService.getActiveTypeStatelist().subscribe((response) => {
        this.repState.stateList = response
      })
    }
  }

  initGrid() {
    this.clientService
      .getIaStatesForRep({ repId: this.repId })
      .subscribe((response) => {
        this.repState.repIaStates = response.map((ias) => new IaState(ias))
      })
  }

  public addHandler({ sender }) {
    const newIaState = new IaState(null)
    newIaState.repId = this.repId
    newIaState.active = true
    this.addHandlerShared({ sender }, newIaState)
  }

  public saveHandler({ sender, rowIndex, formGroup, isNew }): void {
    const iaState = new IaState(formGroup.value)
    iaState.repId = this.repId
    this.clientService.submitIaStateUpdate(iaState).subscribe(() => {
      sender.closeRow(rowIndex)
      this.initGrid()
    })
  }

  public removeHandler({ dataItem }) {
    const itemToRemove = new IaState(dataItem)
    itemToRemove.active = false
    this.clientService.removeIaStateUpdate(itemToRemove).subscribe(() => {
      this.initGrid()
    })
  }

  public createFormGroup(iaState: IaState): UntypedFormGroup {
    return this.formBuilder.group({
      active: iaState.active,
      bdfees: iaState.iafees,
      repIAStateID: iaState.repIAStateID,
      repId: iaState.repId,
      state: [iaState.state, Validators.required],
      stateText: iaState.stateText,
    })
  }
}
